export const removeLineBreaks = (str: string) => str.replace(/(\r\n|\n|\r)/gm, "");